import { cn } from '@heidi/utils';

/**
 * Skip-link targets are large fill containers, often direct children of a
 * rounded `overflow-hidden` ancestor (the inset SidebarInset card). The shared
 * outset `focusRing` gets fully clipped there — and the border-swap fallback
 * is invisible on these borderless containers — so targets use an INSET
 * outline instead: painted inside the border-box (immune to ancestor
 * clipping) and following the element's own border-radius.
 *
 * `rounded-[inherit]` makes that radius track the direct parent automatically,
 * so every target hugs its container's corners (rounded inset card → rounded
 * outline; square panel → square outline) with no per-call-site wiring. A
 * target that owns its own radius overrides by passing `rounded-*` via the
 * `className` param (cn keeps the later class).
 */
export const skipLinkTargetFocusClasses = cn(
  'rounded-[inherit] outline-none focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-border-focus/50'
);

export const skipLinkBaseClasses = cn(
  'transition-none',
  'sr-only start-[-9999em] top-[-9999em] outline-none',
  // z-index stays on `focus-visible:` (not `focus:`) to beat the shared focus ring's `focus-visible:z-10`.
  'focus:not-sr-only focus:absolute focus:start-1 focus:top-1 focus:size-auto focus:px-2 focus-visible:z-[100000]'
);
